import { useEffect, useRef } from 'react';

const useIdleLogout = (onLogout, timeout = 20 * 60 * 1000) => {
	const timeoutRef = useRef(null);

	const resetTimer = () => {
		if (timeoutRef.current) clearTimeout(timeoutRef.current);
		timeoutRef.current = setTimeout(() => {
			onLogout(); // Trigger logout function
		}, timeout);
	};

	useEffect(() => {
		const events = ['mousemove', 'keydown', 'scroll', 'click'];

		const handleActivity = () => resetTimer();

		events.forEach((event) => window.addEventListener(event, handleActivity));
		resetTimer(); // Start timer on mount

		return () => {
			events.forEach((event) =>
				window.removeEventListener(event, handleActivity)
			);
			if (timeoutRef.current) clearTimeout(timeoutRef.current);
		}; //eslint-disable-next-line
	}, []);
};

export default useIdleLogout;
